import Icon from '../components/Icon.vue'

Icon.register({
  bolt: {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M296 160c18.5 0 30 20.1 20.7 36l-176 304c-4.4 7.6-12.4 12-20.8 12-15.3 0-26.9-14.3-23.3-29.5l46.1-194.5h-118.7c-14.5 0-25.7-12.8-23.8-27.2l32-240c1.6-11.9 11.8-20.8 23.8-20.8h144c15.7 0 27.2 15 23.2 30.2l-42.6 129.8h115.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bolt.js
// module id = 670
// module chunks = 0